module.exports = __webpack_public_path__ + "img/warning.219b5d65.png";